import { ACTIONS } from "../../../Models/ENUM";
import CONQUER from "../../CONQUER";
import GameInstance from "../GameInstance";
import GameCurrency from "./GameCurrency";
import LOG, { log } from "../../../UTIL/LOG";

class GameWallet
{
    private gameInstance;
    private conquer     : CONQUER;
    private vars        : any;
    public currencies   : any = {};
    private gameID      : any;


    constructor( gameInstance:GameInstance )
    {
        this.gameInstance   = gameInstance;
        this.gameID         = gameInstance.gameID;
        this.conquer        = gameInstance.conquer;
    }

    public init( data:any )
    {
        this.vars           = { gameID:this.gameInstance.gameID };

        for( let name in this.currencies )
        {
            let found = false;
            for( let n in data ) 
            {
                if( data[n].name == name ) 
                {
                    found = true;
                    break
                }
            }

            if( found ) continue;
 
            delete this.currencies[ name ];
        }

        for( let n in data ) this.setCurrency( data[n] );
    }

    public async get( currencyName?:any ) : Promise<any>
    {
        if( currencyName )
        {
            let gameCurrency = await this.getCurrency( currencyName );
            
            return Promise.resolve( gameCurrency );
        }

        this.vars.avatarID = this.conquer.Avatars.ME.avatarID;
        
        this.currencies = {};
 
        let entries : any = await this.conquer.do( ACTIONS.GAME_CURRENCY_GET, this.vars );
 
        for( let n in entries ) await this.setCurrency( entries[n] );
 
        return Promise.resolve( this.currencies );
    };

    public async getPublic( avatarID:any, names:any )
    {
        let results     = await this.conquer.do( ACTIONS.GAME_CURRENCY_GET, { gameID:this.gameID, avatarID:avatarID, names:names });
        return Promise.resolve( results );
    }

    private async setCurrency( currencyData:any ) : Promise<any>
    {
        let gameCurrency : GameCurrency = this.currencies[ currencyData.name ] = this.currencies[ currencyData.name ] || new GameCurrency( this.gameInstance );
 
        gameCurrency.fill( currencyData );

        return Promise.resolve( gameCurrency );
    };

    public async increase( currencyName:any, amount:number ) : Promise<any>
    {
        let gameCurrency = await this.getCurrency( currencyName );

        await gameCurrency.increase( amount );

        return Promise.resolve( gameCurrency );
    };

    public async getCurrency( currencyName:any ) : Promise<any>
    {
        let gameCurrency : GameCurrency = this.currencies[ currencyName ];

        if( gameCurrency ) return Promise.resolve( gameCurrency );

        let currencyData = await this.conquer.do( ACTIONS.GAME_CURRENCY_GETONE, { gameID:this.vars.gameID, name:currencyName } );
 
        return this.setCurrency( currencyData );
    }
 
}

export default GameWallet;